import type { CreateVehicleLogInput, PaginatedResult, UpdateVehicleLogInput, VehicleLog } from '@container-system/shared';
import { apiRequest } from './client';

export const vehicleLogsApi = {
  list: (page = 1, pageSize = 50) => apiRequest<PaginatedResult<VehicleLog>>(`/api/vehicle-logs?page=${page}&pageSize=${pageSize}`),
  create: (input: CreateVehicleLogInput) => apiRequest<VehicleLog>('/api/vehicle-logs', { method: 'POST', body: JSON.stringify(input) }),
  update: (id: string, input: UpdateVehicleLogInput) =>
    apiRequest<VehicleLog>(`/api/vehicle-logs/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  remove: (id: string) => apiRequest<null>(`/api/vehicle-logs/${id}`, { method: 'DELETE' }),
};
